// extracted by mini-css-extract-plugin
export default {"svg_icon":"svgIcon_svg_icon__uPY0X","svg_icon--hide-empty-container":"svgIcon_svg_icon--hide-empty-container__NCkRP"};